import classNames from 'classnames'
import styles from './AIAnalysisTag.module.css'
import { AI_ANALYSIS_META } from '../utlis/aiAnalysis'
import Pill from './Pill'
export default function AIAnalysisTag({ analysis, className }) {
  if (!analysis) {
    return <Pill className={className}>-</Pill>
  }

  const meta =
    typeof analysis === 'string'
      ? AI_ANALYSIS_META[analysis]
      : AI_ANALYSIS_META[analysis?.key] ?? analysis

  if (!meta) {
    return <Pill className={className}>{typeof analysis === 'string' ? analysis : '-'}</Pill>
  }

  return (
    <span className={classNames(styles.tag, styles[meta.key], className)}>
      {meta.icon ? (
        <span
          className={styles.icon}
          role='img'
          aria-label={meta.iconLabel || meta.label}
        >
          {meta.icon}
        </span>
      ) : null}
      <span className={styles.text}>{meta.label}</span>
    </span>
  )
}
